<template>
    <div class="vehicle-details-content">
        <SectionContainer
            title="Informações do Veículo"
            icon="car"
        >
            <!-- Header com foto do veículo -->
            <div class="vehicle-header">
                <div class="row">
                    <div class="col-12">
                        <!-- Grid de informações principais do veículo -->
                        <div class="vehicle-info-grid">
                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-car-side"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Descrição:</div>
                                    <div class="card-value">
                                        {{ getVehicleDescription() }}
                                    </div>
                                </div>
                            </div>

                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-hashtag"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Placa:</div>
                                    <div class="card-value plate-value">
                                        {{ getVehicleBoard() }}
                                    </div>
                                </div>
                            </div>

                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-list"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Tipo do Veículo:</div>
                                    <div class="card-value">
                                        {{ reserve.vehicle_type_id ? reserve.vehicle_type_id.description : 'N/A' }}
                                    </div>
                                </div>
                            </div>

                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-tachometer-alt"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Km do Veículo:</div>
                                    <div class="card-value km-value">
                                        {{ formatKilometers(reserve.vehicles ? reserve.vehicles.current_km : 0) }} km
                                    </div>
                                </div>
                            </div>

                            <div class="info-card">
                                <div class="card-icon">
                                    <i class="fas fa-gas-pump"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Combustível:</div>
                                    <div class="card-value fuel-value">
                                        {{ reserve.vehicles ? reserve.vehicles.combustible : 'N/A' }}
                                    </div>
                                </div>
                            </div>

                            <div class="info-card" v-if="reserve.vehicles && reserve.vehicles.color">
                                <div class="card-icon">
                                    <i class="fas fa-palette"></i>
                                </div>
                                <div class="card-content">
                                    <div class="card-label">Cor:</div>
                                    <div class="card-value">
                                        {{ reserve.vehicles.color }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Informações adicionais se disponíveis -->
            <div class="additional-vehicle-info mt-4" v-if="hasAdditionalInfo()">
                <div class="row">
                    <div class="col-md-6" v-if="reserve.vehicles && reserve.vehicles.year">
                        <div class="additional-info-card">
                            <div class="info-header">
                                <i class="fas fa-calendar-alt"></i>
                                <span>Ano do Veículo</span>
                            </div>
                            <div class="info-value">
                                {{ reserve.vehicles.year }}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="reserve.vehicles && reserve.vehicles.model">
                        <div class="additional-info-card">
                            <div class="info-header">
                                <i class="fas fa-cog"></i>
                                <span>Modelo</span>
                            </div>
                            <div class="info-value">
                                {{ reserve.vehicles.model }}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="reserve.vehicles && reserve.vehicles.brand">
                        <div class="additional-info-card">
                            <div class="info-header">
                                <i class="fas fa-industry"></i>
                                <span>Marca</span>
                            </div>
                            <div class="info-value">
                                {{ reserve.vehicles.brand }}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6" v-if="reserve.vehicles && reserve.vehicles.renavam">
                        <div class="additional-info-card">
                            <div class="info-header">
                                <i class="fas fa-id-card"></i>
                                <span>RENAVAM</span>
                            </div>
                            <div class="info-value">
                                {{ reserve.vehicles.renavam }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Status do veículo se disponível -->
            <div class="vehicle-status mt-4" v-if="reserve.vehicles && reserve.vehicles.vehicle_status">
                <SectionContainer
                    title="Status do Veículo"
                    icon="info-circle"
                >
                    <div class="status-display">
                        <span
                            class="status-badge-large"
                            :class="getVehicleStatusClass(reserve.vehicles.vehicle_status)"
                        >
                            <i class="fas fa-circle"></i>
                            {{ reserve.vehicles.vehicle_status.description || 'Status não informado' }}
                        </span>
                    </div>
                </SectionContainer>
            </div>
        </SectionContainer>
    </div>
</template>

<script>
import SectionContainer from "../../Modals/Checklist/SectionContainer.vue";
import {shouldHideVehicleData} from "../../../composables/useVehicleVisibility";

export default {
    components: {
        SectionContainer
    },
    props: {
        reserve: { // reserve - dados da reserva contendo informações do veículo
            type: Object,
            required: true
        }
    },
    methods: {
        getVehicleDescription() {
            const user = this.$store.state.user;
            if (shouldHideVehicleData(user, this.reserve)) {
                return 'Veículo Oculto';
            }
            return this.reserve.vehicles ? this.reserve.vehicles.description : 'N/A';
        },
        getVehicleBoard() {
            const user = this.$store.state.user;
            if (shouldHideVehicleData(user, this.reserve)) {
                return '***-***';
            }
            return this.reserve.vehicles ? this.reserve.vehicles.board : 'N/A';
        },
        formatKilometers(value) { // formatKilometers - formata quilometragem com pontos
            if (!value) return '0';
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        hasAdditionalInfo() { // hasAdditionalInfo - verifica se há informações adicionais do veículo
            if (!this.reserve.vehicles) return false;

            return this.reserve.vehicles.year ||
                this.reserve.vehicles.model ||
                this.reserve.vehicles.brand ||
                this.reserve.vehicles.renavam;
        },
        getVehicleStatusClass(status) { // getVehicleStatusClass - retorna classe CSS para status do veículo
            if (!status || !status.id) return 'status-unknown';

            const statusClasses = {
                1: 'status-available', // Disponível
                2: 'status-reserved', // Reservado
                3: 'status-maintenance', // Manutenção
                4: 'status-unavailable' // Indisponível
            };

            return statusClasses[status.id] || 'status-unknown';
        }
    }
};
</script>

<style scoped>
.vehicle-details-content {
    padding: 20px;
    background-color: white;
}

/* Header do veículo */
.vehicle-header {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
}

.vehicle-photo-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    background-color: white;
    border-radius: 8px;
    border: 2px solid #e2e8f0;
    overflow: hidden;
}

.vehicle-photo {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.vehicle-photo:hover {
    transform: scale(1.05);
}

.no-photo-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #6c757d;
    opacity: 0.6;
}

.no-photo-placeholder i {
    font-size: 48px;
    margin-bottom: 10px;
}

/* Grid de informações do veículo */
.vehicle-info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;
}

.info-card {
    background-color: white;
    border-radius: 8px;
    padding: 16px;
    border-left: 4px solid #f8981d;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    gap: 15px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.info-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.card-icon {
    width: 40px;
    height: 40px;
    background-color: #f8981d;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.card-icon i {
    color: white;
    font-size: 16px;
}

.card-content {
    flex: 1;
}

.card-label {
    font-size: 13px;
    color: #6c757d;
    margin-bottom: 4px;
    font-weight: 500;
}

.card-value {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
}

.plate-value {
    background-color: #f8981d;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    display: inline-block;
    font-family: monospace;
    font-size: 14px;
    letter-spacing: 1px;
}

.km-value {
    color: #FE8D18 !important;
    font-size: 18px;
}

.fuel-value {
    color: #28a745 !important;
}

/* Informações adicionais */
.additional-vehicle-info {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 20px;
}

.additional-info-card {
    background-color: white;
    border-radius: 8px;
    padding: 16px;
    border-left: 4px solid #6c757d;
    margin-bottom: 15px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.info-header {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
    font-size: 14px;
}

.info-header i {
    color: #6c757d;
    width: 16px;
}

.info-value {
    color: #2c3e50;
    font-size: 16px;
    font-weight: 500;
}

/* Status do veículo */
.vehicle-status {
    background-color: white;
}

.status-display {
    display: flex;
    justify-content: center;
    padding: 20px;
}

.status-badge-large {
    padding: 12px 24px;
    border-radius: 25px;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 1px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
}

.status-available {
    background-color: #28a745;
    color: #ffffff;
}

.status-reserved {
    background-color: #FE8D18;
    color: #ffffff;
}

.status-maintenance {
    background-color: #ffc107;
    color: #212529;
}

.status-unavailable {
    background-color: #dc3545;
    color: #ffffff;
}

.status-unknown {
    background-color: #6c757d;
    color: #ffffff;
}

/* Responsividade */
@media (max-width: 768px) {
    .vehicle-details-content {
        padding: 15px;
    }

    .vehicle-header {
        padding: 15px;
    }

    .vehicle-photo-container {
        height: 150px;
        margin-bottom: 20px;
    }

    .vehicle-info-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }

    .info-card {
        padding: 12px;
    }

    .card-icon {
        width: 35px;
        height: 35px;
    }

    .card-icon i {
        font-size: 14px;
    }

    .card-value {
        font-size: 14px;
    }

    .km-value {
        font-size: 16px;
    }

    .additional-vehicle-info {
        padding: 15px;
    }
}

@media (max-width: 576px) {
    .additional-info-card {
        padding: 12px;
        margin-bottom: 10px;
    }

    .info-value {
        font-size: 14px;
    }

    .status-badge-large {
        padding: 10px 20px;
        font-size: 14px;
    }

    .plate-value {
        font-size: 12px;
        padding: 3px 6px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/view-components/ViewDataVehicle.vue